'use strict';

var angular = require('angular');
var PendingUserRequestDirective = function PendingUserRequestDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/pending-user-request.html'),
    controller: 'PendingUserRequestController',
    scope: {
      user: '=',
      pendingNumbers: '='
    },
    link: function link($scope) {
      $scope.showApproveModal = function () {
        angular.element('#approve-modal').modal('show');
      };
      $scope.showRejectModal = function () {
        angular.element('#reject-modal').modal('show');
      };
    }
  };
};
PendingUserRequestDirective.inject = [];
module.exports = PendingUserRequestDirective;